import { render, staticRenderFns } from "./MunicipalKeepingStatistics.vue?vue&type=template&id=f7ad12ca&scoped=true&"
import script from "./MunicipalKeepingStatistics.vue?vue&type=script&lang=js&"
export * from "./MunicipalKeepingStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ad12ca",
  null
  
)

export default component.exports